import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import bankAccountsService from '../services/bankAccountsService';
import '../assets/bankAccountCreate.css';

const BankAccountCreate = () => {
  const navigate = useNavigate();
  
  // Form state
  const [formData, setFormData] = useState({
    name: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name.trim()) {
      setError('Bank account name is required');
      return;
    }

    try {
      setIsSubmitting(true);
      setError('');
      
      const response = await bankAccountsService.createBankAccount(formData);
      
      if (response.success) {
        // Navigate back to bank accounts list
        navigate('/bank-accounts');
      } else {
        throw new Error(response.message || 'Failed to create bank account');
      }
    } catch (err) {
      console.error('Error creating bank account:', err);
      setError(err.message || 'Failed to create bank account');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle cancel button
  const handleCancel = () => {
    navigate('/bank-accounts');
  };

  return (
    <div className="bank-account-create-container">
      <div className="container-fluid">
        {/* Breadcrumb */}
        <nav className="breadcrumb">
          <span className="breadcrumb-item">
            <a href="/dashboard">Dashboard</a>
          </span>
          <span className="breadcrumb-item">
            <a href="/bank-accounts">GG Bank Accounts</a>
          </span>
          <span className="breadcrumb-item active">Create GG Bank Account</span>
        </nav>

        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default panel-standard">
              {/* Panel Header */}
              <div className="panel-heading">
                <h3 className="panel-title">Create GG Bank Account</h3>
              </div>

              {/* Panel Body */}
              <div className="panel-body">
                {error && (
                  <div className="alert alert-danger">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit} className="form-horizontal">
                  <fieldset className="form-horizontal">
                    <div className="form-group">
                      <label htmlFor="name" className="col-sm-3 control-label label-required">
                        Name <span className="required">*</span>
                      </label>
                      <div className="col-sm-5">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter bank account name"
                          required
                        />
                      </div>
                    </div>
                  </fieldset>

                  <fieldset className="form-horizontal">
                    <div className="form-group text-right">
                      <div className="col-sm-12">
                        <button
                          type="submit"
                          className="btn btn-head btn-standard"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Creating...' : 'Create'}
                        </button>
                        <button
                          type="button"
                          className="btn btn-default"
                          onClick={handleCancel}
                          style={{ marginLeft: '10px' }}
                        >
                          CANCEL
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankAccountCreate;